import {
  DatePickerWithLabel,
  Section,
  SectionRow,
  TextInputWithLabel,
} from "dsl/ecosystems/PatientForms/components";
import { FormWatcher } from "react-forms-state/src";
import { useTranslations } from "translations";

export const PriorTreatmentSection = () => {
  const translations = useTranslations();
  return (
    <Section
      title={
        translations.patientForms.transitionalCareForm.hospitalStay
          .titlePriorStay
      }
    >
      <SectionRow>
        <DatePickerWithLabel
          bold
          disableFuture
          elementName="prior_treatment_start_date"
          label={
            translations.patientForms.transitionalCareForm.hospitalStay
              .intakeDate
          }
        />
        <FormWatcher watchPath="prior_treatment_start_date">
          {({ watchedValue }) => {
            return (
              <DatePickerWithLabel
                blockBefore={watchedValue}
                bold
                elementName="prior_treatment_end_date"
                label={
                  translations.patientForms.transitionalCareForm.hospitalStay
                    .releaseDate
                }
              />
            );
          }}
        </FormWatcher>
        <TextInputWithLabel
          bold
          elementName="prior_treatment_hospital_id"
          label={translations.patientForms.transitionalCareForm.hospitalStay.id}
          large
        />
      </SectionRow>
    </Section>
  );
};
